module.exports = __webpack_public_path__ + "static/media/stacie.0edbfcdf.png";